//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "interactive",
  data() {
    return {
      activeIndex: 0,
      list:[]
    }
  },
  methods: {
    open(e) {
      if (e == this.activeIndex) {
        this.activeIndex = null;
      } else {
        this.activeIndex = e;
      }
    }
  },
  created() {
    this.axios.post('/xcx/User/interaction').then(res=>{
      this.list=res.data.data
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/interactive/interactive.vue